var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "#828282",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7.62479V9.49979H2.375L7.905 3.96979L6.03 2.09479L0.5 7.62479ZM9.355 2.51979C9.55 2.32479 9.55 2.00979 9.355 1.81479L8.185 0.644785C7.99 0.449785 7.675 0.449785 7.48 0.644785L6.565 1.55979L8.44 3.43479L9.355 2.51979Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditpen);
export default __webpack_public_path__ + "static/media/editpen.77c8ad2caccd41ade499b48c089c97d9.svg";
export { ForwardRef as ReactComponent };